import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Phone } from 'lucide-react';
import { getWhatsAppLink } from '../../utils/whatsapp';
const flow = ['LLAMADA ENTRANTE', 'VOICE', 'IDENTIFICA', 'ENTIENDE', 'CALIFICA', 'AGENDA', 'CRM'];
export function Voice() {
  return <section id="voice" className="bg-arena py-[72px] md:py-[120px]" data-id="element-258" data-mp="68z830rvmx6t">
      <div className="max-w-[1000px] mx-auto px-6 md:px-20" data-id="element-259" data-mp="k9jqvwxskt0b">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="bg-carbon rounded-[12px] p-8 md:p-14 text-center" data-id="element-260" data-mp="k7yyodyy9m5m">
          <span className="inline-flex items-center gap-1.5 font-body text-[11px] uppercase tracking-[0.15em] text-salvia mb-5" data-id="element-261" data-mp="yyy0n65a5cg8">
            <Phone size={12} data-id="element-262" data-mp="1vo1hy6sgrg08" /> ORIGEN VOICE
          </span>
          <h2 className="font-display text-[28px] md:text-[40px] font-bold text-arena leading-[1.15] max-w-[560px] mx-auto mb-4" data-id="element-263" data-mp="20m32yx9g9pec">
            Tu empresa también puede contestar el teléfono.
          </h2>
          <p className="font-body text-[16px] md:text-[18px] text-arena/60 leading-[1.6] max-w-[480px] mx-auto mb-10" data-id="element-264" data-mp="29mj3bxuwcgez">
            Un agente de voz con IA que atiende, entiende, califica, agenda
            y deriva cuando hace falta.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-1.5 mb-10" data-id="element-265" data-mp="2jjdzia3p64q3">
            {flow.map((step, idx) => <Fragment key={step} data-id="element-266" data-mp="2oe1f1jgq3osj" data-mpi={idx}>
                <span className="font-body text-[12px] text-arena/75 bg-arena/10 rounded-full px-3.5 py-1.5" data-id="element-267" data-mp="2sdsgch3vlnbb">
                  {step}
                </span>
                {idx < flow.length - 1 && <span className="text-arena/30 text-[12px]" data-id="element-268" data-mp="32anbqr4ur7ld">→</span>}
              </Fragment>)}
          </div>

          {/* Mini call demonstration */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.4,
          ease: 'easeOut'
        }} className="bg-arena/5 border border-arena/15 rounded-[12px] p-6 max-w-[440px] mx-auto text-left mb-10" data-id="element-269" data-mp="xadvse9ey7lg">
            <div className="space-y-2.5" data-id="element-270" data-mp="1kxvfdmiixzdc">
              <motion.p initial={{
              opacity: 0,
              y: 6
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.3,
              delay: 0.1
            }} className="font-body text-[13px] text-arena/85" data-id="element-271" data-mp="1gyd5rmw5lapt">
                <span className="text-arena/40" data-id="element-272" data-mp="j1v1s5g3d1y">Cliente — </span>
                "Hola, quiero saber si tienen disponibilidad esta semana."
              </motion.p>
              <motion.p initial={{
              opacity: 0,
              y: 6
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.3,
              delay: 0.3
            }} className="font-body text-[13px] text-verde font-medium" data-id="element-273" data-mp="3rshdjncxl61w">
                <span className="text-verde/60" data-id="element-274" data-mp="22gvj9hflcd2h">VOICE — </span>
                "Claro. ¿Qué servicio necesitas?"
              </motion.p>
            </div>

            <div className="h-px bg-arena/10 my-4" data-id="element-275" data-mp="1ojp4rz1wh0j2" />

            <div className="flex flex-col gap-2" data-id="element-276" data-mp="1tgz1lzrmcegx">
              <motion.div initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.3,
              delay: 0.5
            }} data-id="element-277" data-mp="1tembgzbpixss">
                <span className="font-body text-[10px] uppercase tracking-[0.1em] text-azul" data-id="element-278" data-mp="38x7m3vtcyj4e">
                  INTENCIÓN DETECTADA ✓
                </span>
                <p className="font-body text-[12.5px] text-arena/70 mt-0.5" data-id="element-279" data-mp="3dug33t2rsh42">
                  Servicio: Consulta
                </p>
              </motion.div>
              <motion.div initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.3,
              delay: 0.65
            }} data-id="element-280" data-mp="19u0slf5lav8n">
                <span className="font-body text-[10px] uppercase tracking-[0.1em] text-salvia" data-id="element-281" data-mp="zww1r20subli">
                  DISPONIBILIDAD ✓
                </span>
                <p className="font-body text-[12.5px] text-arena/70 mt-0.5" data-id="element-282" data-mp="q3x2mq7of2nn">
                  Jueves · 10:00 · Jueves · 15:00
                </p>
              </motion.div>
              <motion.div initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.3,
              delay: 0.8
            }} data-id="element-283" data-mp="h4k24n1j5of2">
                <span className="font-body text-[12.5px] font-medium text-arena/85" data-id="element-284" data-mp="76dzu4btag9o">
                  CRM · Lead actualizado ✓
                </span>
              </motion.div>
            </div>
          </motion.div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-5" data-id="element-285" data-mp="233hrn6uncm9">
            <a href={getWhatsAppLink('Hola, equipo de Origen Studio. Quiero agregar el módulo VOICE a mi sistema.')} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-arena text-carbon font-display font-semibold text-[15px] px-7 py-3.5 rounded-[6px] hover:bg-[#EAE7E0] transition-colors duration-200" data-id="element-286" data-mp="70v6y9g40kmr">
              Agregar VOICE <ArrowRight size={16} className="ml-2" data-id="element-287" data-mp="3p6rs5lqxcyhz" />
            </a>
            <div className="text-left" data-id="element-288" data-mp="2rqklsmgtc6fg">
              <p className="font-body text-[14px] font-medium text-arena/80" data-id="element-289" data-mp="2rpjcamfg3rzu">
                Desde $1.500.000/mes
              </p>
              <p className="font-body text-[12px] text-arena/40" data-id="element-290" data-mp="2wnb4lhk05g4k">
                Disponible como módulo adicional.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}